import { useContext, useEffect, useRef, useState } from "react";
import { PiEnvelopeLight, PiListLight, PiMapPinLight, PiPhoneLight } from "react-icons/pi";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { GlobalContext } from "../../../context";
import { logoutHandler } from "../../../context/actions/auth";
import VonLoginModal from "../VonLoginModal/VonLoginModal";
import VonRegistrationModal from "../VonRegistrationModal/VonRegistrationModal";
import Logo from "./assets/logo.png";
import { IoIosArrowDown } from "react-icons/io";
import { FaArrowRightLong } from "react-icons/fa6";
import Avatar1 from "../../../assets/images/Avatar-4.png";
import Avatar2 from "../../../assets/images/Avatar-5.png";
import Avatar3 from "../../../assets/images/Avatar-6.png";
import Avatar4 from "../../../assets/images/Avatar-7.png";
import Avatar5 from "../../../assets/images/Avatar-8.png";
import { Avatar, AvatarGroup, Box, Typography } from "@mui/material";

export default function VonHeader() {
    const {
        authState: { data, loggedIn },
        authDispatch,
    } = useContext(GlobalContext);
    const user = data?.user || {};
    const [registerOpen, setRegisterOpen] = useState(false);
    const [loginOpen, setLoginOpen] = useState(false);
    const [currentModal, setCurrentModal] = useState("register");
    const [menuOpen, setMenuOpen] = useState(false);
    const [isDesktopCompanyMenuOpen, setIsDesktopCompanyMenuOpen] = useState(false);
    const [isMobileCompanyMenuOpen, setIsMobileCompanyMenuOpen] = useState(false);
    const [userMenuOpen, setUserMenuOpen] = useState(false);

    const desktopDropdownRef = useRef(null);
    const mobileDropdownRef = useRef(null);
    const userDropdownRef = useRef(null);
    const modalRef = useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
            if (desktopDropdownRef.current && !desktopDropdownRef.current.contains(event.target)) {
                setIsDesktopCompanyMenuOpen(false);
            }
            if (userDropdownRef.current && !userDropdownRef.current.contains(event.target)) {
                setUserMenuOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const location = useLocation();
    const navigate = useNavigate();

    const isActive = (pathname) => {
        return location.pathname === pathname;
    };

    const handleLogout = async () => {
        await logoutHandler(authDispatch);
        navigate("/");
    };

    const handleSpecificDivClickRegister = (e) => {
        e.stopPropagation();
        setRegisterOpen(true);
        setLoginOpen(false);
        setCurrentModal("register");
    };

    const handleSpecificDivClickLogin = (e) => {
        e.stopPropagation();
        setLoginOpen(true);
        setRegisterOpen(false);
        setCurrentModal("login");
    };

    useEffect(() => {
        const handleOutsideClick = (e) => {
            if (modalRef.current && !modalRef.current.contains(e.target)) {
                setRegisterOpen(false);
                setLoginOpen(false);
            }
        };
        document.addEventListener("click", handleOutsideClick);
        return () => {
            document.removeEventListener("click", handleOutsideClick);
        };
    }, []);

    const studentAvatars = [Avatar1, Avatar2, Avatar3, Avatar4, Avatar5];

    return (
        <header className="fixed top-0 left-0 right-0 w-full z-50 transition-all duration-300">
            {/* Top Sleek Utility Bar */}
            <div className="hidden md:flex bg-[#0b0f19] text-[#94a3b8] text-xs py-2 px-[6%] justify-between items-center border-b border-slate-800/50">
                <div className="flex gap-6 items-center">
                    <div className="flex gap-2 items-center hover:text-white transition-colors">
                        <PiPhoneLight className="text-sm text-[#d15424]" />
                        <Link to="tel:+12029339591">+1 (202) 933-9591</Link>
                    </div>
                    <div className="w-[1px] h-3 bg-slate-800" />
                    <div className="flex gap-2 items-center hover:text-white transition-colors">
                        <PiEnvelopeLight className="text-sm text-[#d15424]" />
                        <Link to="mailto:info@e1xacademy.net">info@e1xacademy.net</Link>
                    </div>
                </div>
                <div className="flex gap-2 items-center">
                    <PiMapPinLight className="text-sm text-[#d15424]" />
                    <span>7404 Executive Place, Lanham MD 20706, USA</span>
                </div>
            </div>

            {/* Main Header / Navigation */}
            <div className="bg-white/95 backdrop-blur-md border-b border-slate-100 shadow-sm px-[6%] py-3 md:py-4 transition-all duration-300">
                <div className="max-w-7xl mx-auto flex justify-between items-center">
                    {/* Logo */}
                    <Link to="/" className="flex items-center">
                        <img
                            src={Logo}
                            alt="E1X Academy"
                            className="h-10 md:h-12 w-auto object-contain transition-transform duration-300 hover:scale-[1.02]"
                        />
                    </Link>

                    {/* Desktop Navigation */}
                    <nav className="hidden md:flex items-center gap-12">
                        <Link
                            to="/"
                            className={`font-semibold text-sm transition-colors duration-200 ${
                                isActive("/") ? "text-[#d15424]" : "text-slate-700 hover:text-[#d15424]"
                            }`}
                        >
                            Home
                        </Link>

                        <Link
                            to="/courses"
                            className={`font-semibold text-sm transition-colors duration-200 ${
                                isActive("/courses") ? "text-[#d15424]" : "text-slate-700 hover:text-[#d15424]"
                            }`}
                        >
                            Courses
                        </Link>

                        {/* Company Dropdown */}
                        <div className="relative" ref={desktopDropdownRef}>
                            <button
                                onClick={() => setIsDesktopCompanyMenuOpen(!isDesktopCompanyMenuOpen)}
                                className={`font-semibold text-sm transition-colors duration-200 flex items-center gap-1.5 ${
                                    isDesktopCompanyMenuOpen ? "text-[#d15424]" : "text-slate-700 hover:text-[#d15424]"
                                }`}
                            >
                                Company{" "}
                                <IoIosArrowDown
                                    className={`transition-transform duration-300 text-xs ${
                                        isDesktopCompanyMenuOpen ? "rotate-180 text-[#d15424]" : "text-slate-400"
                                    }`}
                                />
                            </button>

                            {isDesktopCompanyMenuOpen && (
                                <div className="absolute top-10 -left-48 bg-white border border-slate-100 shadow-2xl rounded-2xl md:w-[680px] z-50 p-8 transform origin-top transition-all duration-300 animate-in fade-in slide-in-from-top-2">
                                    <div className="flex flex-row justify-between mb-6 pb-4 border-b border-slate-50 items-center">
                                        <div className="flex items-center gap-2">
                                            <span className="block w-2 h-2 rounded-full bg-[#d15424]" />
                                            <span className="text-[10px] font-bold tracking-[0.2em] uppercase text-slate-400">
                                                E1X Ecosystem
                                            </span>
                                        </div>
                                        <Box sx={{ display: "flex", alignItems: "center", flexDirection: "row" }}>
                                            <AvatarGroup max={5} sx={{ mr: 1, "& .MuiAvatar-root": { width: 24, height: 24, fontSize: 10 } }}>
                                                {studentAvatars.map((avatar, index) => (
                                                    <Avatar key={index} src={avatar} alt={`Student ${index + 1}`} />
                                                ))}
                                            </AvatarGroup>
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    color: "#475569",
                                                    fontFamily: "Robout, sans-serif",
                                                    fontWeight: 500,
                                                    fontSize: "11px",
                                                }}
                                            >
                                                Join our learning community
                                            </Typography>
                                        </Box>
                                    </div>

                                    <div className="grid grid-cols-3 gap-8">
                                        <div>
                                            <h4 className="font-bold text-xs uppercase tracking-wider text-slate-400 mb-4">About & Support</h4>
                                            <div className="flex flex-col gap-3">
                                                <Link to="/about" onClick={() => setIsDesktopCompanyMenuOpen(false)} className="text-sm font-semibold text-slate-700 hover:text-[#d15424] flex items-center justify-between group">
                                                    About Us <FaArrowRightLong className="text-slate-300 group-hover:text-[#d15424] group-hover:translate-x-1 transition-all" />
                                                </Link>
                                                <Link to="/contact" onClick={() => setIsDesktopCompanyMenuOpen(false)} className="text-sm font-semibold text-slate-700 hover:text-[#d15424] flex items-center justify-between group">
                                                    Contact Us <FaArrowRightLong className="text-slate-300 group-hover:text-[#d15424] group-hover:translate-x-1 transition-all" />
                                                </Link>
                                                <Link to="/alumni-stories" onClick={() => setIsDesktopCompanyMenuOpen(false)} className="text-sm font-semibold text-slate-700 hover:text-[#d15424] flex items-center justify-between group">
                                                    Alumni Stories <FaArrowRightLong className="text-slate-300 group-hover:text-[#d15424] group-hover:translate-x-1 transition-all" />
                                                </Link>
                                            </div>
                                        </div>

                                        <div>
                                            <h4 className="font-bold text-xs uppercase tracking-wider text-slate-400 mb-4">E1X Hub</h4>
                                            <div className="flex flex-col gap-3">
                                                <Link to="/blog" onClick={() => setIsDesktopCompanyMenuOpen(false)} className="text-sm font-semibold text-slate-700 hover:text-[#d15424] flex items-center justify-between group">
                                                    Blog Insights <FaArrowRightLong className="text-slate-300 group-hover:text-[#d15424] group-hover:translate-x-1 transition-all" />
                                                </Link>
                                                <Link to="/webinars-events" onClick={() => setIsDesktopCompanyMenuOpen(false)} className="text-sm font-semibold text-slate-700 hover:text-[#d15424] flex items-center justify-between group">
                                                    Events & Meetups <FaArrowRightLong className="text-slate-300 group-hover:text-[#d15424] group-hover:translate-x-1 transition-all" />
                                                </Link>
                                            </div>
                                        </div>

                                        <div>
                                            <h4 className="font-bold text-xs uppercase tracking-wider text-slate-400 mb-4">Partnership</h4>
                                            <div className="flex flex-col gap-3">
                                                <Link to="/sponsor" onClick={() => setIsDesktopCompanyMenuOpen(false)} className="text-sm font-semibold text-slate-700 hover:text-[#d15424] flex items-center justify-between group">
                                                    Sponsors <FaArrowRightLong className="text-slate-300 group-hover:text-[#d15424] group-hover:translate-x-1 transition-all" />
                                                </Link>
                                                <Link to="/talents" onClick={() => setIsDesktopCompanyMenuOpen(false)} className="text-sm font-semibold text-slate-700 hover:text-[#d15424] flex items-center justify-between group">
                                                    Talents Portal <FaArrowRightLong className="text-slate-300 group-hover:text-[#d15424] group-hover:translate-x-1 transition-all" />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        <Link
                            to="/consultancy"
                            className={`font-semibold text-sm transition-colors duration-200 ${
                                isActive("/consultancy") ? "text-[#d15424]" : "text-slate-700 hover:text-[#d15424]"
                            }`}
                        >
                            Consultancy
                        </Link>

                        {user?.is_instructor && (
                            <Link
                                to="/instructors-upload"
                                className={`font-semibold text-sm transition-colors duration-200 ${
                                    isActive("/instructors-upload") ? "text-[#d15424]" : "text-slate-700 hover:text-[#d15424]"
                                }`}
                            >
                                Assignment
                            </Link>
                        )}
                    </nav>

                    {/* Action Buttons / User Menu */}
                    <div className="hidden md:flex items-center gap-4">
                        {loggedIn ? (
                            <div className="relative" ref={userDropdownRef}>
                                <button
                                    onClick={() => setUserMenuOpen(!userMenuOpen)}
                                    className="flex items-center gap-2 px-3 py-1.5 rounded-full hover:bg-slate-50 border border-slate-100 transition-all duration-300"
                                >
                                    {user?.profile_img ? (
                                        <img
                                            src={user.profile_img}
                                            alt="avatar"
                                            className="w-8 h-8 rounded-full object-cover border-2 border-[#d15424]"
                                        />
                                    ) : (
                                        <div className="w-8 h-8 rounded-full bg-[#d15424] text-white flex items-center justify-center font-bold text-xs uppercase">
                                            {user?.firstname?.[0] || "U"}
                                        </div>
                                    )}
                                    <span className="text-sm font-semibold text-slate-700">{user?.firstname}</span>
                                    <IoIosArrowDown className={`text-slate-400 text-xs transition-transform duration-200 ${userMenuOpen ? "rotate-180" : ""}`} />
                                </button>

                                {userMenuOpen && (
                                    <div className="absolute right-0 top-12 bg-white border border-slate-100 shadow-xl rounded-2xl w-48 py-2 z-50 transform origin-top-right transition-all animate-in fade-in slide-in-from-top-2">
                                        <Link
                                            to="/dashboard"
                                            onClick={() => setUserMenuOpen(false)}
                                            className="flex items-center px-4 py-2.5 text-sm font-semibold text-slate-600 hover:bg-slate-50 hover:text-[#d15424] transition-colors"
                                        >
                                            Dashboard
                                        </Link>
                                        <Link
                                            to="/dashboard/settings"
                                            onClick={() => setUserMenuOpen(false)}
                                            className="flex items-center px-4 py-2.5 text-sm font-semibold text-slate-600 hover:bg-slate-50 hover:text-[#d15424] transition-colors"
                                        >
                                            Profile Settings
                                        </Link>
                                        <div className="border-t border-slate-50 my-1"></div>
                                        <button
                                            onClick={() => { setUserMenuOpen(false); handleLogout(); }}
                                            className="flex items-center w-full px-4 py-2.5 text-sm font-semibold text-red-500 hover:bg-red-50 transition-colors text-left"
                                        >
                                            Logout
                                        </button>
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div className="flex items-center gap-3">
                                <button
                                    onClick={() => navigate("/sign-in")}
                                    className="text-sm font-semibold text-slate-700 hover:text-[#d15424] transition-colors px-4 py-2"
                                >
                                    Login
                                </button>
                                <button
                                    onClick={() => navigate("/login")}
                                    className="bg-[#d15424] text-white text-sm font-bold pl-5 pr-2 py-2 hover:bg-[#0b0f19] transition-all duration-300 flex items-center gap-3 group rounded-full"
                                >
                                    Get Started
                                    <div className="w-7 h-7 rounded-full bg-white flex items-center justify-center text-[#d15424] group-hover:bg-[#d15424] group-hover:text-white transition-colors">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className="w-3.5 h-3.5">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                                        </svg>
                                    </div>
                                </button>
                            </div>
                        )}
                    </div>

                    {/* Mobile Menu Icon */}
                    <div className="md:hidden flex items-center">
                        <button
                            onClick={() => setMenuOpen(!menuOpen)}
                            className="text-slate-800 text-3xl hover:text-[#d15424] transition-colors"
                        >
                            <PiListLight />
                        </button>
                    </div>
                </div>
            </div>

            {/* Mobile Navigation Drawer */}
            <div
                className={`fixed inset-0 bg-[#0b0f19]/40 backdrop-blur-sm z-40 md:hidden transition-opacity duration-300 ${
                    menuOpen ? "opacity-100 visible" : "opacity-0 invisible pointer-events-none"
                }`}
                onClick={() => setMenuOpen(false)}
            />

            <nav
                className={`fixed top-0 right-0 bottom-0 w-[80%] max-w-sm bg-white z-50 md:hidden shadow-2xl flex flex-col p-6 transition-transform duration-300 ease-out transform ${
                    menuOpen ? "translate-x-0" : "translate-x-full"
                }`}
            >
                <div className="flex justify-between items-center mb-8 border-b border-slate-50 pb-4">
                    <img src={Logo} alt="logo" className="h-8 w-auto object-contain" />
                    <button
                        onClick={() => setMenuOpen(false)}
                        className="text-slate-500 hover:text-slate-800 text-xl font-bold"
                    >
                        ✕
                    </button>
                </div>

                <div className="flex flex-col gap-5 overflow-y-auto flex-1">
                    <Link
                        to="/"
                        className={`font-semibold text-base py-2 border-b border-slate-50 transition-colors ${
                            isActive("/") ? "text-[#d15424]" : "text-slate-700"
                        }`}
                        onClick={() => setMenuOpen(false)}
                    >
                        Home
                    </Link>

                    <Link
                        to="/courses"
                        className={`font-semibold text-base py-2 border-b border-slate-50 transition-colors ${
                            isActive("/courses") ? "text-[#d15424]" : "text-slate-700"
                        }`}
                        onClick={() => setMenuOpen(false)}
                    >
                        Courses
                    </Link>

                    {/* Mobile Dropdown for Company */}
                    <div ref={mobileDropdownRef}>
                        <button
                            onClick={() => setIsMobileCompanyMenuOpen(!isMobileCompanyMenuOpen)}
                            className="font-semibold text-base py-2 border-b border-slate-50 w-full text-left flex justify-between items-center text-slate-700"
                        >
                            Company
                            <IoIosArrowDown className={`transition-transform duration-200 text-xs ${isMobileCompanyMenuOpen ? "rotate-180" : ""}`} />
                        </button>

                        {isMobileCompanyMenuOpen && (
                            <div className="bg-slate-50/50 rounded-xl p-3 flex flex-col gap-2.5 mt-2 ml-2 animate-in slide-in-from-top-2 duration-200">
                                <Link to="/about" onClick={() => { setMenuOpen(false); setIsMobileCompanyMenuOpen(false); }} className="text-sm font-semibold text-slate-600 hover:text-[#d15424]">About Us</Link>
                                <Link to="/contact" onClick={() => { setMenuOpen(false); setIsMobileCompanyMenuOpen(false); }} className="text-sm font-semibold text-slate-600 hover:text-[#d15424]">Contact Us</Link>
                                <Link to="/alumni-stories" onClick={() => { setMenuOpen(false); setIsMobileCompanyMenuOpen(false); }} className="text-sm font-semibold text-slate-600 hover:text-[#d15424]">Alumni Stories</Link>
                                <Link to="/blog" onClick={() => { setMenuOpen(false); setIsMobileCompanyMenuOpen(false); }} className="text-sm font-semibold text-slate-600 hover:text-[#d15424]">Blog Post</Link>
                                <Link to="/webinars-events" onClick={() => { setMenuOpen(false); setIsMobileCompanyMenuOpen(false); }} className="text-sm font-semibold text-slate-600 hover:text-[#d15424]">Events</Link>
                                <Link to="/sponsor" onClick={() => { setMenuOpen(false); setIsMobileCompanyMenuOpen(false); }} className="text-sm font-semibold text-slate-600 hover:text-[#d15424]">Sponsors</Link>
                                <Link to="/talents" onClick={() => { setMenuOpen(false); setIsMobileCompanyMenuOpen(false); }} className="text-sm font-semibold text-slate-600 hover:text-[#d15424]">Talents</Link>
                            </div>
                        )}
                    </div>

                    <Link
                        to="/consultancy"
                        className={`font-semibold text-base py-2 border-b border-slate-50 transition-colors ${
                            isActive("/consultancy") ? "text-[#d15424]" : "text-slate-700"
                        }`}
                        onClick={() => setMenuOpen(false)}
                    >
                        Consultancy
                    </Link>
                </div>

                {/* Mobile Bottom Section (Auth) */}
                <div className="pt-6 border-t border-slate-100 mt-auto">
                    {loggedIn ? (
                        <div className="flex flex-col gap-4">
                            <div className="flex items-center gap-3">
                                {user?.profile_img ? (
                                    <img
                                        src={user.profile_img}
                                        alt="avatar"
                                        className="w-10 h-10 rounded-full object-cover border-2 border-[#d15424]"
                                    />
                                ) : (
                                    <div className="w-10 h-10 rounded-full bg-[#d15424] text-white flex items-center justify-center font-bold text-sm">
                                        {user?.firstname?.[0] || "U"}
                                    </div>
                                )}
                                <div>
                                    <h4 className="text-sm font-bold text-slate-800">{user?.firstname} {user?.lastname}</h4>
                                    <p className="text-xs text-slate-400">{user?.email}</p>
                                </div>
                            </div>
                            <Link
                                to="/dashboard"
                                onClick={() => setMenuOpen(false)}
                                className="block py-2.5 text-sm font-semibold text-slate-600 hover:text-[#d15424]"
                            >
                                Dashboard
                            </Link>
                            <Link
                                to="/dashboard/settings"
                                onClick={() => setMenuOpen(false)}
                                className="block py-2.5 text-sm font-semibold text-slate-600 hover:text-[#d15424]"
                            >
                                Profile Settings
                            </Link>
                            <button
                                onClick={() => { setMenuOpen(false); handleLogout(); }}
                                className="w-full bg-red-50 text-red-500 py-3 rounded-xl font-bold hover:bg-red-100 transition-colors text-center text-sm"
                            >
                                Logout
                            </button>
                        </div>
                    ) : (
                        <div className="flex flex-col gap-3">
                            <button
                                onClick={() => { setMenuOpen(false); navigate("/sign-in"); }}
                                className="w-full border border-slate-200 text-slate-700 py-3 rounded-full font-bold hover:bg-slate-50 transition-colors text-sm"
                            >
                                Login
                            </button>
                            <button
                                onClick={() => { setMenuOpen(false); navigate("/sign-up"); }}
                                className="w-full bg-[#d15424] text-white py-3 rounded-full font-bold hover:bg-[#0b0f19] transition-colors text-sm"
                            >
                                Register
                            </button>
                        </div>
                    )}
                </div>
            </nav>

            {/* Modals Container */}
            <div
                className={
                    registerOpen || loginOpen
                        ? "fixed inset-0 h-screen w-full bg-black/60 backdrop-blur-sm z-[100] flex justify-center items-center p-4"
                        : "hidden"
                }
            >
                <div className="w-full max-w-md transform transition-all duration-300 scale-100" ref={modalRef}>
                    {currentModal === "register" ? (
                        <VonRegistrationModal switchToLogin={handleSpecificDivClickLogin} />
                    ) : (
                        <VonLoginModal
                            onClose={() => setLoginOpen(false)}
                            switchToRegister={handleSpecificDivClickRegister}
                        />
                    )}
                </div>
            </div>
        </header>
    );
}
